import { FC, useCallback } from 'react';
import { SearchAutocomplete, SearchOption } from '@/components/ui';
import { wizardService, type IndustryOption } from '@/services';

interface IndustryAutocompleteProps {
  value: string;
  onChange: (value: string) => void;
  onSelect?: (industryId: number, industryName: string) => void;
  error?: string;
  required?: boolean;
}

export const IndustryAutocomplete: FC<IndustryAutocompleteProps> = ({
  value,
  onChange,
  onSelect,
  error,
  required,
}) => {
  const searchIndustries = useCallback(async (query: string): Promise<SearchOption[]> => {
    try {
      const results: IndustryOption[] = await wizardService.searchIndustries(query);
      return (results || []).map((item) => ({
        id: item.id,
        name: item.name,
        subtitle: item.linkedinCode ? `LinkedIn Code: ${item.linkedinCode}` : undefined,
      }));
    } catch (error) {
      console.error('Error searching industries:', error);
      return [];
    }
  }, []);

  const handleSelect = useCallback((option: SearchOption) => {
    onChange(option.name);
    if (onSelect && typeof option.id === 'number') {
      onSelect(option.id, option.name);
    }
  }, [onChange, onSelect]);

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      onSearch={searchIndustries}
      error={error}
      required={required}
      label="Industry"
      placeholder="Start typing to search industries..."
      minSearchLength={2}
      onSelect={handleSelect}
    />
  );
};
